export function doesLocalOverrideExist(appName?: string): appName is string {
  if (process.env.NODE_ENV === 'production' || !appName) return false
  return !!getLocalOverrideUrl(appName)
}

export function getLocalOverrideUrl(appName: string): string | undefined {
  if (process.env.NODE_ENV === 'production') return
  try {
    const overrides = JSON.parse(localStorage.getItem('localDevServerOverrides') || '[]')
    const override = overrides.find((override: { name: string }) => override.name === appName) as
      | {
          name: string
          path?: string
          entry?: string
        }
      | undefined
    if (override) {
      const redirect = `/${override.path ?? override.name}/${override.entry ?? 'index.html'}`
      console.log(`Redirecting ${appName} to local ${redirect}`)
      return redirect
    }
  } catch (e) {
    console.error('Error checking local overrides', e)
    return undefined
  }
}
